// extracted by mini-css-extract-plugin
export var picker = "_8-0";